module.exports = __webpack_public_path__ + "f8ec314588d8d5fbd6b79969d5f65de8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2097_teaser_image.jpg
// module id = 597
// module chunks = 0